import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

export function Logo({ className = "", withWordmark = true }) {
    return (
        <span className={cn("inline-flex items-center gap-2", className)}>
            <img
                src="/phoebus-logo.png"
                alt="Phoebus AI"
                className="h-7 w-auto"
                width="140"
                height="30"
                decoding="async"
            />
        </span>
    );
}

export function Eyebrow({ children, className = "", light = false }) {
    return (
        <div
            className={cn(
                "flex items-center gap-2.5 font-mono text-xs uppercase tracking-[0.18em]",
                light ? "text-pa-blue-050/80" : "text-pa-ink-500",
                className,
            )}
        >
            <span className="step-tick" aria-hidden="true" />
            <span>{children}</span>
        </div>
    );
}

export function Section({ children, className = "", dark = false, id }) {
    return (
        <section
            id={id}
            className={cn(
                "px-5 sm:px-8 lg:px-16 py-20 md:py-28",
                dark ? "bg-pa-ink-900 text-white" : "bg-pa-paper text-pa-ink-900",
                className,
            )}
        >
            <div className="mx-auto max-w-[1180px]">{children}</div>
        </section>
    );
}

// Restrained scroll reveal (short distance, short duration, small stagger)
export function Reveal({ children, delay = 0, className = "", as = "div" }) {
    const reduce = useReducedMotion();
    const Comp = motion[as] || motion.div;
    if (reduce) return <Comp className={className}>{children}</Comp>;
    return (
        <Comp
            className={className}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </Comp>
    );
}
